import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get } from 'api/fetch';

export const fetchVouchers = createAsyncThunk(
  'nomad_insurance/vouchers/fetchAvailableVouchers',
  async (provider, { getState, rejectWithValue }) => {
    const state = getState();
    const { userID } = state.app.user;
    if (!userID) {
      return;
    }

    try {
      const availableVouchers = await get(`/vouchers/v1/providers/${provider}`, {
        isNIOrchestrator: true
      });

      return availableVouchers;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// ================== Reducers ================== //

const slice = createSlice({
  name: 'nomad_insurance/vouchers',
  initialState: {
    availableVouchers: undefined,
    isLoading: false,
    error: false
  },
  reducers: {},
  extraReducers: {
    [fetchVouchers.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchVouchers.rejected]: (state, { payload }) => {
      state.availableVouchers = null;
      state.isLoading = false;
      state.error = payload;
    },
    [fetchVouchers.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      state.availableVouchers = payload;
    }
  }
});

// ================== Actions ================== //
export const { ...actions } = slice.actions;
export default slice.reducer;
